import { Button, Col, Container, Modal } from "react-bootstrap";
import styled from "styled-components";
import { colors, types } from "../../libs";

export const PageLayout = styled.div`
  display: flex;
  height: calc(100vh - 70px);
  width: 100%;
  overflow: hidden;
`;
export const LeftSection = styled.div`
  flex: 70%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  
`;
export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width:1111px
`;

export const VersionName = styled.span`
  ${types.headers.itemMedium};
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  flex: 1;
`;
export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`;


export const RightSection = styled.div`
  flex: 30%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px; 
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const CustomButton = styled(Button)<{ hoverWidth?: string }>`
  width: 40px;
  padding: 6px; 
  overflow: hidden;
  white-space: nowrap;

  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.3s ease;
  border: 1px solid ${colors.background.greyWhite};

  &:hover {
    width: ${props => props.hoverWidth || "120px"};
    padding: 6px 12px;
    border: 1px solid ${colors.background.greyWhite};
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 26px;
    height: 26px;
  }
`;

export const Label = styled.span`
  display: none;
  margin-left: 8px;
  opacity: 0;
  transform: translateX(-10px);
  transition:
    opacity 0.2s ease-out 0.15s,
    transform 0.2s ease-out 0.15s;

  ${CustomButton}:hover & {
    display: inline-block;
    opacity: 1;
    transform: translateX(0);
  }
`;


export const IconStyled = styled.div`
  margin-right: 8px;

  svg {
    width: 20px;
    height: 20px;
  }
`;
export const InfoIconStyled = styled.div`
  margin-right: 8px;
  display: inline-block;
`;

export const SaveButton = styled(Button)`
`;

export const Description = styled.p`
 ${types.body.normal};
  color: ${colors.text.gray};
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ThumbnailImage = styled.img`
  height: 75px;
  margin: auto;
  object-fit: cover;
  border-radius: 5px;
`;

export const TableWrapper = styled.div`
    overflow-x: auto;
    max-height: 75vh;
    width: 100%;
    border-radius: 0.5rem;
    padding-bottom: 3.5rem;
    
    &::-webkit-scrollbar {
        display: none;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th, td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
        
    }

    th {
        color: #808080;
          ${types.body.subtitle};
    }

    /* Set column widths */
    th:nth-child(1), td:nth-child(1) { 
        width: 40px;
        text-align: center;
    }
  
    th:nth-child(2), td:nth-child(2) {
        width: 87px;
    }

    th:nth-child(3), td:nth-child(3) { 
        width: 200px;
    }

    th:nth-child(4), td:nth-child(4) { 
        padding-left: 40px; 
    }
`;

export const NoResultsText = styled.p`
    color: ${colors.text.white};
    padding: 1rem;
`;
export const PreviewWrapper = styled(Col)`
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  padding: 20px;
  align-items: center;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${colors.background.smokyBlack};
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.background.greyWhite};
    border-radius: 4px;
  }
`;

export const PreviewIframeWrapper = styled.div`
  position: relative;
  width: 335px;
  height: 225px;
  border-radius: 8px;
  overflow: hidden;
  background: ${colors.background.smokyBlack};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
`;

export const LandscapeIframe = styled.iframe`
  width: 1600px;
  height: 1080px;
  border: none;
  border-radius: 8px;
  transform: scale(0.208);
  transform-origin: top left;
  position: absolute;
  top: 0;
  left: 0;
`;

export const PortraitIframeWrapper = styled.div`
  position: relative;
  width: 90%;
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  background: ${colors.background.smokyBlack};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
`;

export const PortraitIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const LargePreviewIframeWrapper = styled.div`
  position: relative;
  margin: auto;
  width: max(75%, 620px);
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: ${colors.background.smokyBlack};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  height: 90vh;
`;

export const LargeLandscapeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 0;
`;


export const FullscreenPreviewIframeWrapper = styled.div`
  position: relative;
  width: min(92vw, 1400px);
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: ${colors.background.smokyBlack};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  margin: 0 auto;
`;

export const FullscreenLandscapeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const PreviewHeader = styled.h5`
  ${types.body.normal};
  font-weight:600;
  margin-top: 7px;
  color: ${colors.text.gray};

`;

export const DashboardSearchWrapper = styled.div``;

export const SearchBarWrapper = styled.div`
  position: relative;
  width: 254px;
`;

export const SearchInput = styled.input`
  width: 100%;
  border-radius: 20px;
  padding: 8px 50px;
  background: ${colors.background.smokyBlack};;
  color: ${colors.text.white};
  border: 1px solid rgba(255, 255, 255, 0.2);
  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 14px;
  z-index: 1;
`;

export const DescriptionLeftSection = styled.div`
  display: flex;
  align-items: center;
`;

export const DescriptionRightSection = styled.div`
  display: flex;
  align-items: end;
  gap: 8px;
`;

export const HeaderLeftSection = styled(LeftSection)`
  padding: 0;
  margin-bottom: 10px;
`

export const HeaderRightSection = styled(RightSection)`
  padding: 0;
  justify-content: end;
  margin-bottom: 10px;
`

export const NumberHolderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const NumberHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background-color: ${colors.background.darkGray};
  color: ${colors.text.white};
  border: 1px solid ${colors.background.greyWhite};
  font-size: 14px;
`;

export const NumberInput = styled.input`
  width: 40px;
  height: 40px;
  text-align: center;
  border: 1px solid ${colors.background.greyWhite};
  background-color: ${colors.background.darkGray};
  color: ${colors.text.white};
  font-size: 14px;
  
  /* Hide number input spinners/controls */
  -moz-appearance: textfield;
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  &:focus {
    outline: none;
    border-color: #555;
  }
`;

export const NewBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: fit-content;
`;

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CustomActionButton = styled(Button)`
  width: 40px;
  height: 40px;
  padding: 6px; 
  overflow: hidden;
  white-space: nowrap;

  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.3s ease;
  border: 1px solid ${colors.background.greyWhite};
`;

export const FullscreenModalHeader = styled(Modal.Header)`
  border-bottom: 1px solid ${colors.background.greyWhite};

  .btn-close {
    filter: invert(1) grayscale(100%) brightness(200%);
    opacity: 1;
  }
`;